"use client"

import { Card, CardContent, CardHeader, CardTitle } from "@/shared/components/ui/card"
import { Button } from "@/shared/components/ui/button"
import {  FileText } from "lucide-react"

export default function RecursosPage() {
  const recursos = [
    {
      icon: <FileText className="w-6 h-6 text-primary" />,
      title: "Plantilla RIPS - Concepto Recaudo",
      description: "Tabla de referencias con los conceptos de recaudo actualizados.",
      link: "https://res.cloudinary.com/dkj1mpzeu/raw/upload/v1764035936/TablaReferencia_conceptoRecaudo__1_arr97e.xlsx",
      action: "Descargar Plantilla"
    },
    {
      icon: <FileText className="w-6 h-6 text-primary" />,
      title: "Plantilla RIPS - Causa Externa",
      description: "Tabla de referencias con los conceptos de causa externa actualizados.",
      link: "https://res.cloudinary.com/dkj1mpzeu/raw/upload/v1764035937/TablaReferencia_RIPSCausaExternaVersion2__1_1_oazxwg.xlsx",
      action: "Descargar plantilla"
    },
    {
      icon: <FileText className="w-6 h-6 text-primary" />,
      title: "Plantilla RIPS - Finalidad Consulta",
      description: "Tabla de referencias con los conceptos de finalidad de consulta actualizados.",
      link: "https://res.cloudinary.com/dkj1mpzeu/raw/upload/v1764035937/TablaReferencia_RIPSFinalidadConsultaVersion2__1_1_1_qlahyy.xlsx",
      action: "Descargar archivo"
    },
    {
      icon: <FileText className="w-6 h-6 text-primary" />,
      title: "Plantilla RIPS - Servicios CIE10",
      description: "Tabla de referencias con los conceptos de servicios CIE10 actualizados.",
      link: "https://res.cloudinary.com/dkj1mpzeu/raw/upload/v1764035936/tabla_parametros_servicios_3100_2019_4_1_1_gatf1e.xlsx",
      action: "Descargar archivo"
    },
    {
      icon: <FileText className="w-6 h-6 text-primary" />,
      title: "Plantilla RIPS - Municipios",
      description: "Tabla de referencias con los conceptos de municipios actualizados.",
      link: "https://res.cloudinary.com/dkj1mpzeu/raw/upload/v1764035936/municipios_xwegsh.xlsx",
      action: "Descargar archivo"
    },
    {
      icon: <FileText className="w-6 h-6 text-primary" />,
      title: "Plantilla RIPS - CUPS",
      description: "Tabla de referencias con los conceptos de CUPS actualizados.",
      link: "https://res.cloudinary.com/dkj1mpzeu/raw/upload/v1764035937/TablaReferencia_CUPS__1_q3eahw.xlsx",
      action: "Descargar archivo"
    },
    {
      icon: <FileText className="w-6 h-6 text-primary" />,
      title: "Plantilla - Exportacion Masiva",
      description: "Plantilla para la exportación masiva de datos.",
      link: "https://res.cloudinary.com/dkj1mpzeu/raw/upload/v1764035936/Exportacion_Masiva_gqqcxa.xlsx",
      action: "Descargar archivo"
    },
    {
      icon: <FileText className="w-6 h-6 text-primary" />,
      title: "Plantilla -  Referencia CIE10",
      description: "Plantilla para la referencia CIE10.",
      link: "https://res.cloudinary.com/dkj1mpzeu/raw/upload/v1764035937/TablaReferencia_CIE10__1_enddix.xlsx",
      action: "Descargar archivo"
    },
     {
      icon: <FileText className="w-6 h-6 text-primary" />,
      title: "Plantilla - Referencia RIPS Tipo Diagnóstico Principal",
      description: "Plantilla para la referencia RIPS Tipo Diagnóstico Principal.",
      link: "https://res.cloudinary.com/dkj1mpzeu/raw/upload/v1764035937/TablaReferencia_RIPSTipoDiagnosticoPrincipalVersion2__1_1_fwxqtc.xlsx",
      action: "Descargar archivo"
    },
  ]

  return (
    <div className="container mx-auto py-8 px-4 lg:px-6">
      <h1 className="text-3xl font-bold mb-8 text-center">Recursos</h1>
      <div className="grid md:grid-cols-3 gap-6">
        {recursos.map((r, i) => (
          <Card key={i} className="hover:shadow-lg transition-all duration-300">
            <CardHeader className="flex flex-col items-center text-center space-y-2">
              {r.icon}
              <CardTitle>{r.title}</CardTitle>
            </CardHeader>
            <CardContent className="text-center space-y-3">
              <p className="text-muted-foreground">{r.description}</p>
              <Button asChild>
                <a href={r.link} download>{r.action}</a>
              </Button>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  )
}
